// extracted by mini-css-extract-plugin
export default {"root":"Empty_root__Sq9kp","img":"Empty_img__qj0ub","tip":"Empty_tip__Wx6QA","button":"Empty_button__clGef"};